import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownSection,
  DropdownTrigger,
  Image,
} from "@nextui-org/react";
import React, { useEffect, useState, useMemo } from "react";

import logo from "../../Images/logo.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import {
  capitalize,
  getOnedata,
  updateUserLastOrg,
} from "../../controllers/APIController";

const OrgPopUp = ({ List, currOrg, isCollapsed, userDetails }) => {
  const [allOrgInfo, setAllOrgInfo] = useState([]);
  const navigate = useNavigate();
  
  // Use userDetails prop instead of making a separate API call
  useEffect(() => {
    if (userDetails?.OrganizationLists) {
      setAllOrgInfo(userDetails.OrganizationLists);
    }
  }, [userDetails]);

  // Ensure List has no duplicates for React keys
  const uniqueList = useMemo(() => {
    if (!List || !Array.isArray(List)) return [];
    
    // Filter out any problematic values and duplicates
    return List
      .filter(item => item && typeof item === 'string')
      .filter((item, index, self) => self.indexOf(item) === index);
  }, [List]);

  const handleSelectionChange = async (orgURL) => {
    try {
      let orgId = null;
      allOrgInfo?.forEach((ele) => {
        if (ele?.URL === orgURL) {
          orgId = ele.id;
        }
      });

      const UserLogged = JSON.parse(sessionStorage.getItem("userData"));
      const UserId = UserLogged && UserLogged.user.id;
      
      if (UserId) {
        await updateUserLastOrg(UserId, orgURL, orgId);
      }

      navigate(`/${orgURL}/dashboard`);
    } catch (error) {
      console.error('OrgPopUp: Error in organization selection:', error);
    }
  };

  // Safety check: Ensure we have valid data before rendering
  if (!uniqueList || uniqueList.length === 0) {
    return null;
  }

  return (
    <Dropdown>
      <DropdownTrigger className="w-full">
        <div className="flex items-center pt-4 gap-2 cursor-pointer">
          <Image width={30} alt="NextUI hero Image" src={logo} />
          {!isCollapsed && <p className="font-bold">Audyt</p>}
        </div>
      </DropdownTrigger>
      <DropdownMenu
        aria-label="Static Actions"
        className="custom-dropdown-menu"
        disabledKeys={["top", currOrg]}
        disallowEmptySelection
        selectedKeys={[currOrg]}
        defaultSelectedKeys={[currOrg]}
      >
        <DropdownSection className="w-full" aria-label="bottom-section">
          <DropdownItem key="top" className="w-full" textValue={"top"}>
            <span className="text-sm"> Switch to...</span>
          </DropdownItem>
        </DropdownSection>
        <DropdownSection
          className="max-h-28 overflow-auto hide-scrollbar"
          aria-label="mid-section"
        >
          {uniqueList.map((item) => (
            <DropdownItem
              key={`org-${item}`} // Ensure unique key with prefix
              value={item}
              textValue={item}
              endContent={
                currOrg === item && <FontAwesomeIcon icon={faCheck} />
              }
              onPress={() => handleSelectionChange(item)}
            >
              {capitalize(item)}
            </DropdownItem>
          ))}
        </DropdownSection>

        <DropdownSection className="p-0" aria-label="bottom-section">
          <DropdownItem
            key="bottom"
            className="p-0"
            textValue="bottom-section-button"
          >
            <Button
              size="sm"
              className="bg-black w-full text-white text-center cursor-pointer"
              onPress={() => navigate("/org-list")}
            >
              View All Orgnization
            </Button>
          </DropdownItem>
        </DropdownSection>
      </DropdownMenu>
    </Dropdown>
  );
};

export default OrgPopUp;
